/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/11
 */
import * as urls from '../config/urls';
import * as utils from '../utils/fetch';

export const getProductOption = pid =>
  utils.get(`${urls.getProductOption}${pid}`);

export const toEvaluate = payload =>
  utils.post(urls.toEvaluate, payload);

export const toOrder = payload =>
  utils.post(urls.toOrder, payload);



// WEBPACK FOOTER //
// ./src/services/step.js